import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 2H2.01L2 22l4-4h16V2zm-4 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
}), 'MessageSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MessageSharp.js
// module id = 4824
// module chunks = 2